import { TFunction } from 'i18next';
import * as Yup from 'yup';

import { TLanguage } from 'config/tenancy';
import { REGEXES } from 'shared/presentation/constants';
import { isBrazilianCellphoneValid } from 'shared/presentation/helpers';

type TParams = {
  t: TFunction<'authentication'>;
  sharedT: TFunction<'shared'>;
  language: TLanguage;
};

export const MandatoryPhoneSchema = ({ t, sharedT, language }: TParams) =>
  Yup.object({
    phone: Yup.string()
      .required(t('This field is required'))
      .test('Phone format', sharedT('Invalid phone'), value => {
        if (!value) return false;
        if (language === 'pt') return isBrazilianCellphoneValid(value);

        return REGEXES.PHONE[language].test(value);
      }),
  });
